<template>
  <div>
    <popover-last-telemetry-timestamp :deviceId="deviceId" />
    <one-measurement-monitoring
      :deviceId="deviceId"
      :selectedParameter="selectedParameter"
      :readings="readings"
      size="large"
    />
    <device-conditions
      :deviceId="deviceId"
      :lastTelemetryTimestamp="lastTelemetryTimestamp"
    />
  </div>
</template>
<script>
import OneMeasurementMonitoring from '@/components/devicePopover/layouts/OneMeasurementMonitoring.vue'
import popoverLastTelemetryTimestamp from '@/components/devicePopover/content/header/popoverLastTelemetryTimestamp.vue'
import DeviceConditions from '@/components/widgets/currentReadings/content/DeviceConditions.vue'
import { convertArrayToObject } from '@/services/data-conversion'

export default {
  name: 'ContinuousMonitoringContent',
  components: {
    'one-measurement-monitoring': OneMeasurementMonitoring,
    'popover-last-telemetry-timestamp': popoverLastTelemetryTimestamp,
    'device-conditions': DeviceConditions,
  },
  props: {
    deviceId: String,
    selectedParameter: Number,
  },
  computed: {
    lastTelemetryTimestamp() {
      return this.$store.getters['devices/getLastContactByDeviceId'](
        this.deviceId
      )
    },
    readings() {
      return convertArrayToObject(
        this.$store.getters['devices/getSensorReadingsByDeviceId'](
          this.deviceId
        ),
        'name'
      )
    },
  },
}
</script>
